import iconWallet from 'assets/img/dashboard/layout/img/icon-wallet.svg';
import iconInvestment from 'assets/img/dashboard/layout/img/icon-investment.svg';


export const images = {
    wallet: iconWallet,
    investment: iconInvestment,
};
